/* tslint:disable */
/* eslint-disable */
/**
 * Water Bureau Admin Portal - Debug API
 * Debug APIs for development and testing purposes. These APIs bypass authentication and should only be enabled in development environments.
 *
 * The version of the OpenAPI document: debug-1.0.0
 * Contact: debug@waterbureau.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ApiResponseAdminDashboardDTO } from '../backend/model';
/**
 * AdminDashboardApi - axios parameter creator
 * @export
 */
export const AdminDashboardApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieve aggregated dashboard statistics across all councils
         * @summary Get Dashboard Stats
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardStats: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/dashboard`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminDashboardApi - functional programming interface
 * @export
 */
export const AdminDashboardApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminDashboardApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieve aggregated dashboard statistics across all councils
         * @summary Get Dashboard Stats
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDashboardStats(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseAdminDashboardDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDashboardStats(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminDashboardApi.getDashboardStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminDashboardApi - factory interface
 * @export
 */
export const AdminDashboardApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminDashboardApiFp(configuration)
    return {
        /**
         * Retrieve aggregated dashboard statistics across all councils
         * @summary Get Dashboard Stats
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardStats(options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseAdminDashboardDTO> {
            return localVarFp.getDashboardStats(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminDashboardApi - object-oriented interface
 * @export
 * @class AdminDashboardApi
 * @extends {BaseAPI}
 */
export class AdminDashboardApi extends BaseAPI {
    /**
     * Retrieve aggregated dashboard statistics across all councils
     * @summary Get Dashboard Stats
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDashboardApi
     */
    public getDashboardStats(options?: RawAxiosRequestConfig) {
        return AdminDashboardApiFp(this.configuration).getDashboardStats(options).then((request) => request(this.axios, this.basePath));
    }
}

